import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material'
import React from 'react'
import { atom, useRecoilValue, useSetRecoilState } from 'recoil'
// import logConstants from '../utils/logConstants'

type ConfirmDialogBasePropsType = {
    title?: string,
    prompt?: string,
    confirmText?: string,
    cancelText?: string,
    context?: any,
    children?: React.ReactNode,
    confirm?: (context?: any) => void,
    cancel?: (event: {}) => void,
    onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void,
    onEnter?: () => void,
}

type ConfirmDialogPropsType = ConfirmDialogBasePropsType & {
    open: boolean,
}

export const confirmDialogState = atom<ConfirmDialogPropsType>({
    key: 'confirmDialogState',
    default: { open: false, }
})

export const useConfirmDialog = () => {
    const setProps = useSetRecoilState(confirmDialogState)
    const openConfirm = (props: ConfirmDialogBasePropsType) => {
        // console.log(`%copenConfirm: %o`, logConstants.blue12ptBold, props)
        setProps(current => ({ ...current, ...props, open: true, }))
    }
    const closeConfirm = () => {
        // console.log(`%copenConfirm: %o`, logConstants.blue12ptBold)
        setProps(current => ({ ...current, open: false, }))
    }
    return { openConfirm, closeConfirm }
}

export const ConfirmDialogService = () => {
    const props = useRecoilValue(confirmDialogState)
    return (
        <ConfirmDialog {...props} />
    )
}

const ConfirmDialog = (props: ConfirmDialogPropsType) => {
    const handleOnClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === 'escapeKeyDown' && props.cancel) {
            props.cancel(event)
        }
    }
    const handleEntering = () => props.onEnter && props.onEnter()
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose ? props.onClose : handleOnClose}
            TransitionProps={{ onEntering: handleEntering }}
            keepMounted
            sx={{ zIndex: theme => theme.zIndex.modal + 1 }}
        >
            <DialogTitle>
                {props.title ? props.title : 'Eliminazione elemento'}
            </DialogTitle>

            <DialogContent>

                {props.children
                    ? props.children
                    : (
                        <DialogContentText gutterBottom>
                            Procedo con la cancellazione
                        </DialogContentText>
                    )}
                <Typography variant='caption'>
                    <b>{props.prompt ? props.prompt : "Cancello l'elemento?"}</b>
                </Typography>
            </DialogContent>

            <DialogActions>
                {props.confirm &&
                    <Button onClick={(event) => props.confirm && props.confirm(props.context)} variant="text" color="primary" size='small'>
                        {props.confirmText ? props.confirmText : 'SI'}
                    </Button>
                }
                {props.cancel &&
                    <Button onClick={props.cancel} variant="text" size='small'>
                        {props.cancelText ? props.cancelText : 'NO'}
                    </Button>
                }
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog